module.exports = __webpack_public_path__ + "static/media/BDO-BNB.b90788ef.svg";